module.exports = require("ramda/src/map");